import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as Actions from 'vdp-used/actions/vdpUsedActions.js';

import IdentificationAndPrice from 'vdp-used/components/IdentificationPriceSection/IdentificationPriceSection.jsx';

function mapStateToProps(state) {
    return {
        invalidState: (state.vdpUsed && state.vdpUsed.invalidState) || false,
        quote: state.quoteV25,
        quotes: state.quotes,
        vehicle: state.vehicleV25,
        purchaseMethods: state.purchaseMethodsV25,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IdentificationAndPrice);
